import { Heading, LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { CloseButton } from '../../../DesignSystem/LiliCloseButton/CloseButton';
import { VIEWS_MAP } from '../../../router/constants';
import { ReactComponent as BackIcon } from '../../../assets/svg/backBlackIcon.svg';

interface InviteStepHeaderProps {
  onBackClick?: () => void;
}

export const InviteStepHeader = ({ onBackClick }: InviteStepHeaderProps) => {
  const { t } = useTranslation();
  const { t: genT } = useTranslation('generalEn');

  const navigate = useNavigate();
  return (
    <div className='h-[56px] px-[34px] w-full border-b border-b-bw03 bg-surface-primary-bw-00 flex items-center justify-between'>
      <LiliButton
        id='back-button'
        type={LiliButtonType.BACK}
        onClick={onBackClick}
        className={twMerge('w-[82px] h-[32px] rounded-md', !onBackClick && 'invisible')}
        title={genT('CTA.BACK')}
        icon={<BackIcon />}
      />
      <Heading.H8 className='text-text-main-primary'>{t('INVITE_ACCOUNTANT.START.HEADER_TITLE')}</Heading.H8>
      <div className='w-[82px] flex justify-end '>
        <CloseButton onClick={() => navigate(`/${VIEWS_MAP.ACCOUNT_SETTINGS}`)} className='' id='closeFlow' />
      </div>
    </div>
  );
};
